var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup26312(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26312",
    "data-name": "Group 26312",
    transform: "translate(-323 -197)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_228",
    "data-name": "Ellipse 228",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(323 197)",
    fill: "#1859bb"
  }), /*#__PURE__*/React.createElement("text", {
    id: "P",
    transform: "translate(343 225)",
    fill: "#fff",
    fontSize: 20,
    fontFamily: "FontAwesome6Free-Solid, 'Font Awesome \\\\\\\\36  Free'"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6,
    y: 0
  }, "P")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup26312);
export default __webpack_public_path__ + "static/media/Group26312.8b47560cfde1ea12f3212f6d3297ccc6.svg";
export { ForwardRef as ReactComponent };